// src/api/llmGateway/endpoints.ts
/** tc_llm_gateway (par le broker, `/tc_llm`) : les clés des fournisseurs, rôle ADMIN seul. */
export const LLM_GATEWAY_ENDPOINTS = {
  /** Les fournisseurs vus par la passerelle, chacun avec l'état de sa clé (jamais la clé). */
  PROVIDERS: "/admin/providers",
  /** Poser ou changer une clé : testée d'abord, rien n'est écrit si le fournisseur la refuse. */
  KEY: (id: string) => `/admin/providers/${encodeURIComponent(id)}/key`,
  /** Tester une clé candidate (jamais enregistrée) ou, sans corps, la clé enregistrée. */
  TEST: (id: string) => `/admin/providers/${encodeURIComponent(id)}/test`,
} as const;
